/** Check if element is visible based on computed style. */
function isStyleVisible(element: Element) {
    if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) {
        return false;
    }

    const { display, visibility } = element.style;

    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';

    if (isVisible) {
        const { getComputedStyle } = element.ownerDocument.defaultView as any;
        const { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);

        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }

    return isVisible;
}

/** Check if element is visible based on HTML attributes. */
function isAttributeVisible(element: Element, childElement?: Element) {
    return (
        !element.hasAttribute('hidden') &&
        (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY'
            ? element.hasAttribute('open')
            : true)
    );
}

/**
 * Check if element is truly visible (check computed style and HTML attributes that could affect its visibility)
 *
 * Adapted from https://github.com/testing-library/jest-dom and
 * https://github.com/vuejs/vue-test-utils-next/.
 * Licensed under the MIT License.
 * @param element - Element to evaluate for display or visibility.
 */
export function isElementVisible(element: Element, childElement?: Element): boolean {
    return (
        // Not a HTML comments
        element.nodeName !== '#comment' &&
        // Visible based on computed styles
        isStyleVisible(element) &&
        // Visible based on HTML attributes
        isAttributeVisible(element, childElement) &&
        // Has a parent and the parent is visible
        (!element.parentElement || isElementVisible(element.parentElement, element))
    );
}
